import { useState, useCallback } from "react";

const STORAGE_KEY = "proclaw-sidebar-collapsed";

export const SIDEBAR_DEFAULT_WIDTH = 260;
export const SIDEBAR_MIN_WIDTH = 200;
export const SIDEBAR_MAX_WIDTH = 480;

export function useSidebarCollapsed() {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "true";
    } catch {
      return false;
    }
  });

  const toggle = useCallback(() => {
    setCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(STORAGE_KEY, String(next));
      } catch {
        // ignore
      }
      return next;
    });
  }, []);

  return { collapsed, toggle } as const;
}

function clampWidth(w: number): number {
  return Math.min(SIDEBAR_MAX_WIDTH, Math.max(SIDEBAR_MIN_WIDTH, w));
}

// Width is intentionally not persisted — each fresh page load starts at the
// default. Collapsed/expanded state above IS persisted; the exact drag width
// is treated as transient per request.
export function useSidebarWidth() {
  const [width, setWidthState] = useState<number>(SIDEBAR_DEFAULT_WIDTH);

  const setWidth = useCallback((w: number) => {
    setWidthState(clampWidth(w));
  }, []);

  const reset = useCallback(() => {
    setWidthState(SIDEBAR_DEFAULT_WIDTH);
  }, []);

  return { width, setWidth, reset } as const;
}
